import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button.jsx";
import ArrowUp from "./../images/remixicons/Arrows/arrow-drop-up-line.js";
import ArrowDown from "./../images/remixicons/Arrows/arrow-drop-down-line.js";
import SvgIcon from "./SvgIcon.jsx";

export default function SeeMore({ children, heightClass, active = true }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const containerClass = useMemo(() => {
        if (!active) return "";

        const baseClasses = "overflow-hidden see-more-container";
        const closedClasses = isOpen ? "" : `${heightClass} see-more-container-closed`;

        return `${baseClasses} ${closedClasses}`.trim();
    }, [isOpen, heightClass, active]);

    const capitalizeFirstLetter = (str) =>
        str.charAt(0).toUpperCase() + str.slice(1);

    const buttonContent = isOpen ? (
        <span className="flex justify-center items-center">
      {capitalizeFirstLetter(t("see-less"))}
            <span className="w-5 h-5 -mr-1.5">
        <SvgIcon source={ArrowUp} />
      </span>
    </span>
    ) : (
        <span className="flex justify-center items-center">
      {capitalizeFirstLetter(t("see-more"))}
            <span className="w-5 h-5 -mr-1.5">
        <SvgIcon source={ArrowDown} />
      </span>
    </span>
    );

    return (
        <div>
            <div className={containerClass}>{children}</div>
            {active && (
                <div className="text-center pt-3">
                    <Button
                        className="mx-auto"
                        variant="outline-black"
                        size="small"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {buttonContent}
                    </Button>
                </div>
            )}
        </div>
    );
}